import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
export default {
  props: {
    translationsLineDescription: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    translationsLineName: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale'
  }), {
    lineDescription: function lineDescription() {
      return this.translationsLineDescription;
    },
    urlLineName: function urlLineName() {
      return this.buildSearchUrl(this.locale, this.translationsLineName);
    }
  })
};